import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setCategory } from "./store/slices/dropdownSlice";
import "./DropdownGrid.css";

const categories = [
  { name: "Kashmiri Dry Fruits", image: "/thedata/kashmiridryfruits.webp" },
  { name: "Dry Fruits & Nuts", image: "/thedata/DryFriutsAndNuts.webp" },
  { name: "Honey & Saffron", image: "/thedata/KashmiriHoneyAndSaffron.webp" },
  { name: "Dates", image: "/thedata/Dates.webp" },
  { name: "Seeds", image: "/thedata/Seeds.webp" },
  { name: "Hamper Packages", image: "/thedata/WeddingHampers.webp" },
];

export default function Dropdown() {
  const dispatch = useDispatch();

  const handleCategoryChange = (categoryValue) => {
    dispatch(setCategory(categoryValue));
  };

  return (
    <div className="dropdown-container">
      <h2 className="dropdown-title">Shop Our Range</h2>

      <div className="category-grid">
        {categories.map((cat, index) =>
          cat.name === "Stuffed Dates" ? (
            <div key={index} className="category-item coming-soon">
              <img
                src={cat.image}
                alt={cat.name}
                className="category-image"
                loading="lazy"
                onLoad={(e) => e.target.classList.add("loaded")}
              />
              <div className="category-name">{cat.name}</div>
              <div className="coming-soon-text">Coming Soon</div>
            </div>
          ) : (
            <Link
              key={index}
              to="/pubCategory"
              className="category-item"
              onClick={() => handleCategoryChange(cat.name)}
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="category-image"
                loading="lazy"
                onLoad={(e) => e.target.classList.add("loaded")}
              />
              <div className="category-name">{cat.name}</div>
            </Link>
          )
        )}
      </div>
    </div>
  );
}